// ── Foglalás lejáratáig hátralévő idő (Sprint 2A.1 / FELADAT 6) ─────────────
// Külön modul, mert tiszta logika: így unit-tesztelhető anélkül, hogy a teljes
// admin-oldalt (és a routert) be kellene húzni.

/**
 * Emberi formátum a lejáratig: „21 óra”, „5 óra”, „45 perc”, „Lejárt”.
 * @param iso  ISO időbélyeg (expires_at)
 * @param now  aktuális idő ms-ban (tesztelhetőség miatt injektálható)
 * @returns string, vagy null ha nincs/hibás az időpont
 */
export const remaining = (iso, now = Date.now()) => {
  if (!iso) return null;
  const ts = new Date(iso).getTime();
  if (Number.isNaN(ts)) return null;
  const ms = ts - now;
  if (ms <= 0) return 'Lejárt';
  const h = Math.floor(ms / 3600000);
  const m = Math.round((ms % 3600000) / 60000);
  if (h >= 1) return `${h} óra`;
  return `${Math.max(m, 1)} perc`;   // 0 perc helyett 1 perc
};

export default remaining;
